var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#F1F7FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1826 7.87334C14.9317 6.60751 13.9926 6.05334 12.6859 6.05334H7.56423C6.02423 6.05334 4.99756 6.82334 4.99756 8.62001V11.6242C4.99756 12.9192 5.52839 13.6775 6.40339 14.0042C6.53173 14.0508 6.67173 14.0917 6.81756 14.115C7.05089 14.1675 7.30173 14.1908 7.56423 14.1908H12.6917C14.2317 14.1908 15.2584 13.4208 15.2584 11.6242V8.62001C15.2584 8.34584 15.2351 8.10084 15.1826 7.87334ZM7.22589 11C7.22589 11.2392 7.02756 11.4375 6.78839 11.4375C6.54923 11.4375 6.35089 11.2392 6.35089 11V9.25001C6.35089 9.01084 6.54923 8.81251 6.78839 8.81251C7.02756 8.81251 7.22589 9.01084 7.22589 9.25001V11ZM10.1251 11.665C9.27339 11.665 8.58506 10.9767 8.58506 10.125C8.58506 9.27334 9.27339 8.58501 10.1251 8.58501C10.9767 8.58501 11.6651 9.27334 11.6651 10.125C11.6651 10.9767 10.9767 11.665 10.1251 11.665ZM13.8934 11C13.8934 11.2392 13.6951 11.4375 13.4559 11.4375C13.2167 11.4375 13.0184 11.2392 13.0184 11V9.25001C13.0184 9.01084 13.2167 8.81251 13.4559 8.81251C13.6951 8.81251 13.8934 9.01084 13.8934 9.25001V11Z",
    fill: "#509FEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0083 10.37V13.3742C17.0083 15.1708 15.9817 15.9467 14.4358 15.9467H9.31415C8.87665 15.9467 8.48582 15.8825 8.14749 15.7542C7.87332 15.655 7.63415 15.5092 7.44165 15.3225C7.33665 15.2233 7.41832 15.0658 7.56415 15.0658H12.6858C14.8442 15.0658 16.1275 13.7825 16.1275 11.63V8.62C16.1275 8.48 16.285 8.3925 16.3842 8.4975C16.7808 8.9175 17.0083 9.53 17.0083 10.37Z",
    fill: "#509FEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.b4cd39a7.svg";
export { ForwardRef as ReactComponent };